import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { AppHeader } from '../components/AppHeader';
import { AppFooter } from '../components/AppFooter';
import { useScreenInit } from '../useScreenInit';
import { procedures } from '../data/procedures';
import { destinations } from '../data/destinations';
import { facilities } from '../data/facilities';
import { facilitators } from '../data/facilitators';
export function Sitemap() {
  useScreenInit('Sitemap');
  return <div className="min-h-screen bg-slate-50 flex flex-col" data-id="element-1403">
      <Helmet data-id="element-1404">
        <title data-id="element-1405">Sitemap | Affordable Medical Tourism</title>
        <meta name="description" content="Sitemap for Affordable Medical Tourism. Find links to all our procedures, destinations, and company pages." data-id="element-1406" />
      </Helmet>

      <AppHeader data-id="element-1407" />

      <main className="flex-1 w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-1408">
        <h1 className="text-4xl font-bold tracking-tight text-slate-900 mb-10" data-id="element-1409">
          Sitemap
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1410">
          <div data-id="element-1411">
            <h2 className="text-2xl font-semibold text-slate-900 mb-6 border-b border-slate-200 pb-2" data-id="element-1412">
              Main Pages
            </h2>
            <ul className="space-y-3" data-id="element-1413">
              <li data-id="element-1414">
                <Link to="/" className="text-blue-600 hover:underline" data-id="element-1415">
                  Home
                </Link>
              </li>
              <li data-id="element-1416">
                <Link to="/about" className="text-blue-600 hover:underline" data-id="element-1417">
                  About Us
                </Link>
              </li>
              <li data-id="element-1418">
                <Link to="/how-it-works" className="text-blue-600 hover:underline" data-id="element-1419">
                  How It Works
                </Link>
              </li>
              <li data-id="element-1420">
                <Link to="/patient-guide" className="text-blue-600 hover:underline" data-id="element-1421">
                  Patient Guide
                </Link>
              </li>
              <li data-id="element-1422">
                <Link to="/faq" className="text-blue-600 hover:underline" data-id="element-1423">
                  FAQ
                </Link>
              </li>
              <li data-id="element-1424">
                <Link to="/contact" className="text-blue-600 hover:underline" data-id="element-1425">
                  Contact
                </Link>
              </li>
              <li data-id="element-1426">
                <Link to="/partner-facility" className="text-blue-600 hover:underline" data-id="element-1427">
                  Facility Sign-up
                </Link>
              </li>
              <li data-id="element-1428">
                <Link to="/partner-facilitator" className="text-blue-600 hover:underline" data-id="element-1429">
                  Facilitator Sign-up
                </Link>
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 mb-6 mt-12 border-b border-slate-200 pb-2" data-id="element-1430">
              Legal
            </h2>
            <ul className="space-y-3" data-id="element-1431">
              <li data-id="element-1432">
                <Link to="/terms" className="text-blue-600 hover:underline" data-id="element-1433">
                  Terms of Service
                </Link>
              </li>
              <li data-id="element-1434">
                <Link to="/privacy" className="text-blue-600 hover:underline" data-id="element-1435">
                  Privacy Policy
                </Link>
              </li>
              <li data-id="element-1436">
                <Link to="/medical-disclaimer" className="text-blue-600 hover:underline" data-id="element-1437">
                  Medical Disclaimer
                </Link>
              </li>
              <li data-id="element-1438">
                <Link to="/accessibility-statement" className="text-blue-600 hover:underline" data-id="element-1439">
                  Accessibility Statement
                </Link>
              </li>
              <li data-id="element-1440">
                <Link to="/cookie-policy" className="text-blue-600 hover:underline" data-id="element-1441">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-1442">
            <h2 className="text-2xl font-semibold text-slate-900 mb-6 border-b border-slate-200 pb-2" data-id="element-1443">
              Procedures
            </h2>
            <ul className="space-y-3" data-id="element-1444">
              <li data-id="element-1445">
                <Link to="/procedures" className="text-blue-600 hover:underline font-medium" data-id="element-1446">
                  All Procedures
                </Link>
              </li>
              {procedures.map(p => <li key={p.slug} data-id="element-1447">
                  <Link to={`/procedures/${p.slug}`} className="text-blue-600 hover:underline" data-id="element-1448">
                    {p.name}
                  </Link>
                </li>)}
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 mb-6 mt-12 border-b border-slate-200 pb-2" data-id="element-1449">
              Destinations
            </h2>
            <ul className="space-y-3" data-id="element-1450">
              <li data-id="element-1451">
                <Link to="/destinations" className="text-blue-600 hover:underline font-medium" data-id="element-1452">
                  All Destinations
                </Link>
              </li>
              {destinations.map(d => <li key={d.slug} data-id="element-1453">
                  <Link to={`/destinations/${d.slug}`} className="text-blue-600 hover:underline" data-id="element-1454">
                    {d.country}
                  </Link>
                </li>)}
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 mb-6 mt-12 border-b border-slate-200 pb-2" data-id="element-1455">
              Partner Hospitals and Clinics
            </h2>
            <ul className="space-y-3" data-id="element-1456">
              <li data-id="element-1457">
                <Link to="/hospitals" className="text-blue-600 hover:underline font-medium" data-id="element-1458">
                  All Hospitals and Clinics
                </Link>
              </li>
              {facilities.map(f => <li key={f.slug} data-id="element-1459">
                  <Link to={`/hospitals/${f.slug}`} className="text-blue-600 hover:underline" data-id="element-1460">
                    {f.name}
                  </Link>
                </li>)}
            </ul>

            <h2 className="text-2xl font-semibold text-slate-900 mb-6 mt-12 border-b border-slate-200 pb-2" data-id="element-1461">
              Partner Facilitators
            </h2>
            <ul className="space-y-3" data-id="element-1462">
              <li data-id="element-1463">
                <Link to="/facilitators" className="text-blue-600 hover:underline font-medium" data-id="element-1464">
                  All Facilitators
                </Link>
              </li>
              {facilitators.map(f => <li key={f.slug} data-id="element-1465">
                  <Link to={`/facilitators/${f.slug}`} className="text-blue-600 hover:underline" data-id="element-1466">
                    {f.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>
      </main>

      <AppFooter data-id="element-1467" />
    </div>;
}